module.exports = __webpack_public_path__ + "img/0Q3A3375_L_Foamcore_MockedUp.d0908d85.jpg";